import * as React from 'react';
import * as _ from 'underscore';

import { isCurrentUrlViz } from '../../../ts/helpers/UrlHelpers';
import { ServiceLocator } from '../../ServiceLocator';

export const RemoveTrailingSlashWrapper: React.FunctionComponent<{}> = props => {
  const $location = ServiceLocator.get<ng.ILocationService>('$location');
  const path = $location.path();
  if (!isCurrentUrlViz() && path.endsWith('/')) {
    $location.path(path.substring(0, path.length-1));
  }

  return <>{props.children}</>;
};
